const SERVER_TABLE_TOOLBAR_ITEM = Symbol('server-table-toolbar-item');

export type ServerTableToolbarAlign = 'start' | 'end';

export interface ServerTableToolbarItemDefinition {
    role?: 'search'
    /** Which side of the toolbar the control takes while it is not collapsed. */
    align?: ServerTableToolbarAlign
}

type DefinedServerTableToolbarItem = {
    [SERVER_TABLE_TOOLBAR_ITEM]?: ServerTableToolbarItemDefinition
};

export const defineServerTableToolbarItem = <T extends object>(
    component: T,
    definition: ServerTableToolbarItemDefinition = {}
): T => {
    Object.defineProperty(component, SERVER_TABLE_TOOLBAR_ITEM, {value: definition});
    return component;
};

export const getServerTableToolbarItemDefinition = (
    component: unknown
): ServerTableToolbarItemDefinition | undefined => {
    if ((typeof component !== 'function' && typeof component !== 'object') || component === null) {
        return undefined;
    }

    return (component as DefinedServerTableToolbarItem)[SERVER_TABLE_TOOLBAR_ITEM];
};
